<!-- 
  Este arquivo é um exemplo de new de algum model.
  Por si só o new é só uma casca que coloca o form dentro e tem as queries e mutations para criação do registro no banco.
  Por isso ele não tem muito código, basicamente a importação do form.vue
-->
<template>
  <!-- 
    O BaseNew é um componente padrão utilizado em todas as telas do tipo new para facilitar o desenvolvimento. 
    Porém, é importante notar que tudo é enviado para esse componente e ele é quem renderiza o form.
  -->
  <BaseNew
    @new-confirm-action="createEntry" 
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <!-- esse é o slot padrão que está no baseNew para renderizar o form -->
    <template slot="newForm">
      <!-- esse form deve ser criado para cada model -->
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag'; //importacao do gql para queries e mutations do GraphQL
import Form from "./form.vue"; //importacao do form que vai ser renderizado dentro do new
import BaseNew from "@shared_components/base_new.vue"; //importacao do baseNew

export default {
  data() {
    return {
      loading: true, //indica se a tabela está carregando
      pageLoading: false, //indica se a tela está em carregando
      entry: null, //variavel que vai representar o objeto que vai ser criado no new
      formErrors: [], //lista de erros que podem ocorrer quando o usuario salva o novo objeto
      extraData: null, //dados extras que devem ser enviados para o new, como por exemplo listas que vão ser utiizadas em selects
    };
  },
  props: {
    modelNameSingular: String,
  },
  // registros dos componentes
  components: {
    Form: Form, 
    BaseNew: BaseNew
  },
  methods: {
    // metodo chamado quando a tela do new é aberta, 
    // basicamente a função desse método é chamar a query do new do objeto
    // essa query deve retornar um objeto vazio, já considerando valores default
    loadServerEntry: function() {
      this.loading = true; //coloca a modal em estado de loading
      this.$apollo
        .query({
          query: LOAD_NEW_SERVICE_PROVISION,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.serviceProvision; //seta o entry com o objeto vazio 
          this.extraData = response.data; //por padrão eu tenho passado tudo que vem no data, assim o form tem acesso a todas as informações da query
          // console.log(this.extraData)
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false)); //tira a tela do estado de loading ao final da execução daquery

    },
    // função que vai ser chamada quando o usuário clicar no botão de salvar da tela do new
    // basicamente essa função recebe o objeto que está no form, com todos os valores, 
    // e envia esse objeto para o mutation de criação do registro
    createServerEntry: function(serviceProvision) {
      // caso seja necessario verificar o que está sendo recebido do form e está sendo enviado para o mutation, desconmentar as linhas abaixo
      // console.log("Object from Form", serviceProvision)
      // console.log("Validations", serviceProvision.validations)
      // console.log("After Filtering", this.deepFilterEntryWithAllowedFieldsForMutation(serviceProvision, serviceProvision.validations));

      // IMPORTANTE
      // essa funcao abaixo
      // this.deepFilterEntryWithAllowedFieldsForMutation(serviceProvision, serviceProvision.validations)
      // é utilizada para 'limpar' os campos do objeto que vai ser enviado para o mutation
      // esse filtro é realizado de acordo com os campos que vem no validation, 
      // por isso é importante que o validation esteja adequado
      this.pageLoading = true; //coloca a tela toda em modo de carregamento
      let inputObject = this.deepFilterEntryWithAllowedFieldsForMutation(serviceProvision, serviceProvision.validations);
      // console.log(inputObject);
      // return;
      // verifica se o cash_outflow está incompleto e manda null caso estiver
      // if (inputObject.cashOutflowAttributes ) {
      //   if (!inputObject.cashOutflowAttributes.chartId && !inputObject.cashOutflowAttributes.supplierId && inputObject.cashOutflowAttributes.paymentsAttributes && inputObject.cashOutflowAttributes.paymentsAttributes.length == 0 ) {
      //     inputObject.cashOutflowAttributes = null;
      //   }
      // } 
      this.$apollo
        .mutate({
          mutation: CREATE_SERVICE_PROVISION_MUTATION,
          variables: {
            input: inputObject
          }
        })
        .then(response => {
          //recebe os erros que retornaram do server, se nao tiver nenhum a lista está vazia
          var errors = response.data.createServiceProvision.errors

          // console.log(errors);

          if (errors.length){ //se tiver erros, estes sao salvos na variavel que controla os erros e enviados para o baseNew que exibe isso para o usuário
            this.formErrors = errors
          } else {
            //se nao tiver erro significa que o registro foi criado
            //dai: 
            // fecha o modal do new
            this.$refs.baseNew.closeDialog();
            //emite um sinal de que houve a criação de um objeto
            // esse sinal será capturado pelo index, que vai ser atualizado
            this.$emit("entry-created");
            // reseta o formulario para limpar os campos e as validações
            this.resetForm();
          }
        })
        .catch(error => {
          // esse bloco captura algum erro que possa ocorrer em relação a conexão com o banco
          // o erro é capturado e exibido no console do navegador
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false)); //tira a tela do modo de carregamento
    },
    // esse método é o primeiro a ser chamado quando o usuário clica no botao de salvar.
    // dai, ele verifica se o form está valido, ou seja se as validações de campos do form estao validas
    // caso contrário, os campos invalidos entram em estado de erro e o usuário deve corrigi-los antes de prosseguir
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        //se o form está valido chama o create que vai ser executado no server
        this.createServerEntry(this.entry);
      }
    },
    //funcao para resetar o form
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    //funcao para limpar os erros do servidor que sao exibidos para o usuario
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

//exemplo de query do new do objeto
const LOAD_NEW_SERVICE_PROVISION = gql `
{
  accountContext {
    serviceProvision(id: null) {
      id
      code
      type
      patrimonyId
      date
      hourMeter
      odometer
      fueledLiters
      observations
      periodIds
      cashOutflowAttributes {
        id
        code
        billDate
        totalPrice
        periodIds
        chartId
        chart {
          id
          text
        }
        supplierId
        supplier {
          id
          name
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            totalPaidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
        validations
      }
      activitiesAttributes {
        id
        personId
        person {
          id
          name
        }
        durationInHours
        durationInMinutes
        durationText
        patrimonyId
        patrimony {
          id
          description
        }
        implementId
        implement {
          id
          description
        }
      }
      exitMovementItemsAttributes {
        id
        itemId
        item {
          id
          name
          unit {
            id
            name
          }
          brand {
            id
            name
          }
        }
        packagingId
        packaging {
          id
          name
        }
        storageId
        storage {
          id
          name
        }
        quantity
        hasCropLimit
        unitQuantity
      }
      validations
    }
    allPatrimonies {
      id
      description
      workingMetricType
    }
    allPeople {
      id
      name
    }
    allHarvests {
      id
      name
    }
    allPeriodsEnabledForCostApportionment(periodStatuses: [1]) {
      id
      name
      additionalInfo
      secondAdditionalInfo
    }
  }
  globalContext {
    allServiceProvisionTypes
    allPeriodStatuses
  }
}
`;
 
//exemplo de mutation para criar o objeto no banco
const CREATE_SERVICE_PROVISION_MUTATION = gql `
  mutation($input: ServiceProvisionCreateInputObject!) {
    createServiceProvision(input: $input) {
      serviceProvision {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
